import { createContext, useContext, useMemo } from 'react';

const OpportunitiesContext = createContext(null);

export const OpportunitiesProvider = ({
  onDeleteSearchProfile,
  onSaveCurrentSearchProfile,
  isSearchingOrFiltering,
  children,
}) => {
  const context = useMemo(
    () => ({ onDeleteSearchProfile, onSaveCurrentSearchProfile, isSearchingOrFiltering }),
    [onDeleteSearchProfile, onSaveCurrentSearchProfile, isSearchingOrFiltering]
  );

  return <OpportunitiesContext.Provider value={context}>{children}</OpportunitiesContext.Provider>;
};

export const useOpportunities = () => useContext(OpportunitiesContext);
